import {IDrawPredictorStore} from "apps/DRAW_PREDICTOR/modules/types/store";

export const showSupportedCountries = (state: IDrawPredictorStore) =>
	state.modals.supportedCountries;
export const showFanSentiments = (state: IDrawPredictorStore) => state.modals.fanSentiments;
export const showDrawConfirmation = (state: IDrawPredictorStore) => state.modals.drawConfirmation;
export const showEditPick = (state: IDrawPredictorStore) => state.modals.showEditPickModal;
export const showEditPickLite = (state: IDrawPredictorStore) => state.modals.showEditPickLiteModal;

export const showTour = (state: IDrawPredictorStore) => state.modals.tour;
export const getFanFactSquadId = (state: IDrawPredictorStore) => state.modals.fanFactSquad;
export const showRegistration = (state: IDrawPredictorStore) => state.modals.registration;
